var scheduler = {exports: {}};

export { scheduler as __module };
